import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { StatefulArray } from 'ember-data-model-fragments/array/stateful';
import { array } from 'ember-data-model-fragments/attributes';
import type School from '@linc-technologies/linced-common/models/school';
import type Zone from '@linc-technologies/linced-common/models/sif/au/zone';

// Proto: provider_sif_au.Connection.
export default class Connection extends Model {
  declare [Type]: 'sif/au/connection';

  // createTime is when the resource was created in seconds from the epoch.
  @attr('number')
  declare createTime: number | undefined;

  // updateTime is the last time the resource was modified in seconds from the epoch.
  @attr('number')
  declare updateTime: number | undefined;

  // schoolId is the school to which this connection belongs.
  @belongsTo('school', { async: true, inverse: null })
  declare schoolId: AsyncBelongsTo<School>;

  // zoneId is the SIF Zone to be used for this connection.
  @belongsTo('sif/au/zone', { async: true, inverse: null })
  declare zoneId: AsyncBelongsTo<Zone>;

  // syncEnabled determines whether the school can read data from SIF to
  // update the Hero school's resources.
  @attr('boolean', { defaultValue: false })
  declare syncEnabled: boolean;

  // periodicSyncEnabled determines whether to run a periodic SIF->Hero sync.
  @attr('boolean', { defaultValue: false })
  declare periodicSyncEnabled: boolean;

  // stores the last time we synced from SIF. This allows us to only pull
  // data from this point onwards.
  @attr('number', { defaultValue: 0 })
  declare lastSyncTime: number;

  // periodicSyncSteps is a list of steps to perform during a periodic sync.
  @array('number')
  declare periodicSyncSteps: StatefulArray<number>;

  // limitToGroups is a list of group RefIds to limit the student sync to.
  @array('string')
  declare limitToGroups: StatefulArray<string>;
}
